module.exports = __webpack_public_path__ + "img/030.3b024a61.png";